import { Inject, Injectable } from '@angular/core';
import { TBAppEnvironmentVars } from '@monorepo/types';

export const ProcessMappingEndPoint = {
  GET_PROCESS_MAPPING: '/api/v1/listWashingStatus/:factoryId',
  UPDATE_WASHING_STATUS: '/api/v1/saveWashingStatus/:factoryId',
  SEARCH_BCTX: '/api/v1/searchBCTX/:factoryId',
  SEARCH_CMP_ORDER_LIST: '/api/v1/cpm/searchBCTX',
  GET_CPM_ORDER_LIST: '/api/v1/cpm/orderListing',
  GET_CPM_TEMPLATE_LIST: '/api/v1/cpm/templateListing',
  ADD_CPM_TEMPLATE_LIST: '/api/v1/cpm/addTemplate',
  EDIT_CPM_TEMPLATE_LIST: '/api/v1/cpm/editTemplate',
  ADD_CPM_BULK_PROCESS_ORDER: '/api/v1/cpm/bulk/mapProcess',
  EDIT_CPM_PROCESS_ORDER: '/api/v1/cpm/edit/compProcess',
  GET_CPM_TEMPLATE_DETAILS: '/api/v1/cpm/templateDetails',
  GET_BCTX_COMPONENT_DETAILS: '/api/v1/tagdata/getComponentTypes',
  GET_PROCESS_CONFIGURATION: '/api/v1/cpm/getProcessConfiguration',
  GET_PROCESS_ORDER_DETAILS: '/api/v1/cpm/orderDetails',
};

@Injectable({ providedIn: 'root' })
export class ProcessMappingEnvProvider {
  public protocol = 'http';
  public service_host = '';
  public process_mapping_services = '';
  public tags_services = '';
  #API_URL: string;

  constructor(@Inject('environment') ENV: TBAppEnvironmentVars) {
    if (ENV.protocol != null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host != null) {
      this.service_host = ENV.service_host;
    }

    if (ENV.core_services != null) {
      this.process_mapping_services = ENV.process_mapping_services;
    }
    if (ENV.tags_services != null) {
      this.tags_services = ENV.tags_services;
    }
    this.#API_URL = this.protocol + this.service_host + this.process_mapping_services;
  }

  public getUrlFromEnv(arg: keyof typeof ProcessMappingEndPoint): string {
    if (arg === 'GET_BCTX_COMPONENT_DETAILS') {
      return this.protocol + this.service_host + this.tags_services + ProcessMappingEndPoint[arg];
    }
    return this.#API_URL + ProcessMappingEndPoint[arg];
  }
}
